import common from "../../../utils/common";
import c from "../../../utils/constants";

class userMessagesController {
  constructor(UsersService, AuthService) {
    "ngInject"

    this.usersService = UsersService;
    this.authService = AuthService;
  }

  $onInit() {

    this.gridOptions = {
      dataSource: this.usersService.getMessagesDataSource(this.userId, true, () => {}, this.dataSourceErrorSuccessCallback),
      sortable: true,
      pageable: true,
      resizable: true,
      noRecords: {
        template: "No Messages."
      },
      columns: [
        { field: "creationDate", title: "Date", filterable: false, width: "2.5rem", template: `#= kendo.toString(new Date(creationDate), 'dd/MM @ hh:mmtt') #` },
        { field: "messageType", title: "Type", filterable: false, width: "1rem", template: (dataItem) => dataItem.messageType == 1 ? "Email" : dataItem.messageType == 2 ? "SMS" : "Push" },
        { field: "destination", title: "Target", filterable: false, width: "2rem", },
        { field: "title", title: "Title", filterable: false, width: "3rem", },
        { field: "body", title: "Body", filterable: false, width: "8rem", },
        { field: "notificationOutcome", title: "Notification Outcome", filterable: false, sortable: false, width: "3rem", template: (dataItem) => `${this.getNotificationOutcome(dataItem)}` },
        // { field: "notes", title: "Notes", filterable: false, width: "3rem", },
      ]
    };
  }

  getNotificationOutcome(dataItem) {
    if (dataItem.messageType !== 3) return "";

    let outcome = "";

    switch (dataItem.notificationOutcome) {
      case c.notificationOutcome.QUEUED:
        outcome +=  "N/A";
        break;
      case c.notificationOutcome.PROCESSING:
        outcome +=  "Processing";
        break;
      case c.notificationOutcome.COMPLETED:
        outcome +=  "Completed";
        break;
      case c.notificationOutcome.ABANDONED:
        outcome +=  "Abandoned";
        break;
      case c.notificationOutcome.UNKNOWN:
        outcome +=  "Unknown";
        break;
      case c.notificationOutcome.NOTARGETFOUND:
        outcome +=  "No Target Found";
        break;
      case c.notificationOutcome.CANCELLED:
        outcome +=  "Cancelled";
        break;
      default:
        outcome +=  '';
        break;
    }

    if (dataItem.notes) {
      outcome += ' - ' + dataItem.notes;
    }

    return outcome;
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }
}

export default userMessagesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-messages/user-messages.controller.js
 **/